// Payroll deducts social security unless the employee is opted out with
// "Do Not Deduct Pension Contributions" (pensioner), and files it against
// their Social Security Number, so the number is required unless opted out

export const SSN_REQUIRED_MESSAGE =
	"Social Security Number is required unless pension contributions are not deducted";

export const SSN_REQUIRED_HINT =
	'Required unless "Do Not Deduct Pension Contributions" is ticked in Employment Details';

export const OPT_OUT_REQUIRES_SSN_MESSAGE =
	"Enter the Social Security Number in Personal Details, or tick this box";

const hasSsn = (ssn?: string | null) => !!String(ssn ?? "").trim();

/** Whether the employee would be saved without an SSN they need */
export const isSsnMissing = (
	ssn?: string | null,
	pensioner?: boolean | null,
) => pensioner !== true && !hasSsn(ssn);

/**
 * Personal Details check. A new employee's opt-out is only known once
 * Employment Details has been filled in, so it applies from then on.
 */
export const validateSsnRequirement = (
	ssn: string | null | undefined,
	pensioner: boolean | null | undefined,
	optOutKnown: boolean,
): true | string =>
	!optOutKnown || !isSsnMissing(ssn, pensioner) || SSN_REQUIRED_MESSAGE;

/** Employment Details check on the opt-out box */
export const validateOptOut = (
	optedOut: boolean | undefined,
	ssn?: string | null,
): true | string =>
	!isSsnMissing(ssn, optedOut) || OPT_OUT_REQUIRES_SSN_MESSAGE;
